import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = { class: "bg-white rounded-sm inline-flex items-center justify-between p-4 w-full h-[80px]" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("p", { class: "mb-3" }, "Status", -1)
const _hoisted_4 = {
  key: 3,
  class: "bg-red-700 w-3 h-[0.75rem] mr-3 rounded-full inline-flex items-center justify-center"
}
const _hoisted_5 = { class: "text-xl" }
const _hoisted_6 = { class: "text-5xl font-semibold text-black pr-4" }

import { StationBay } from '@/types/interface';
import { LightningBoltIcon, ExclamationIcon, MinusCircleIcon } from '@heroicons/vue/solid';

export default /*#__PURE__*/_defineComponent({
  props: {
    name: null,
    status: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _hoisted_3,
      _createElementVNode("div", {
        class: _normalizeClass(["inline-flex items-center px-3 py-0.5 rounded-full font-medium", {
          'bg-gray-100 text-dark': __props.name === 'Available',
          'bg-green-100 text-green-800': __props.name === 'Charging',
          'bg-yellow-100 text-yellow-800': __props.name === 'Iceing',
          'bg-red-100 text-red-800': __props.name === 'Bay Hogging',
          'bg-blue-100 text-blue-800': __props.name === 'Occupied',
        }])
      }, [
        (__props.name === 'Available' || __props.name === 'Charging')
          ? (_openBlock(), _createBlock(_unref(LightningBoltIcon), {
              key: 0,
              class: _normalizeClass(["h-5 w-5 mr-2", {
            ' text-dark': __props.name === 'Available',
            ' text-green-600': __props.name === 'Charging',
          }])
            }, null, 8, ["class"]))
          : _createCommentVNode("", true),
        (__props.name === 'Occupied')
          ? (_openBlock(), _createBlock(_unref(MinusCircleIcon), {
              key: 1,
              class: "h-5 w-5 text-blue-800 mr-2"
            }))
          : _createCommentVNode("", true),
        (__props.name === 'Iceing')
          ? (_openBlock(), _createBlock(_unref(ExclamationIcon), {
              key: 2,
              class: "h-5 w-5 text-yellow-800 mr-2"
            }))
          : _createCommentVNode("", true),
        (__props.name === 'Bay Hogging')
          ? (_openBlock(), _createElementBlock("span", _hoisted_4))
          : _createCommentVNode("", true),
        _createElementVNode("p", _hoisted_5, _toDisplayString(__props.name), 1)
      ], 2)
    ]),
    _createElementVNode("p", _hoisted_6, _toDisplayString(__props.status.length), 1)
  ]))
}
}

})